
<p-dialog
  [(visible)]="instPopupVisible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  header="Kurum Bilgileri"
  [style]="{ width: '700px', height:'700px' }"
>

  <form [formGroup]="form">
    <div class="form-field">
      <label>
        {{ "instituation.instituation-type" | translate }}
        <span class="text-danger">*</span>
      </label>

      <p-dropdown
        [options]="instituationsTypes"
        formControlName="instituationType"
        [showClear]="true"
        [placeholder]="'general.select-please' | translate"
      ></p-dropdown>
    </div>

    <core-address-autocomplete
      #addressComponent
      [parentForm]="form"
      (setAddress)="handleSetAddress($event)"
      [showCountryPicker]="true"
    ></core-address-autocomplete>

    <div class="actions mt-3 d-flex justify-content-end gap-2">
      <button type="button" pButton label="Kapat" (click)="closeDialog()"></button>
      <button
        type="button"
        pButton
        label="Kaydet"
        class="p-button-primary"
        (click)="save()"
      ></button>
    </div>
  </form>
</p-dialog>
